var scope_0 = require('/Users/arpit/dev/gatsby-theme-candor/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/698837f6411f07a2a76091781fc8a00f.js').default;
var scope_1 = require('/Users/arpit/dev/gatsby-theme-candor/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    